import { isNotBlank } from 'utils/string';

/**
 * 多项搜索框数组监听赋值
 */
export default {
  data() {
    return {
      // 提供默认值，可以被组件覆盖
      checkboxConfig: {
        formRef: 'searchForm', // 表单的 ref
        tableRef: 'tableRef', // 列表表格的 ref
        targetArray: [], // 这里通过传递引用来更新原 data
        onCheck: null, // 勾选时的回调
        onUncheck: null, // 取消勾选时的回调
        searchFunc: null, // 搜索回调函数
        transform: null, // 值转换函数
      },
    };
  },

  mounted() {
    this.initCheckboxWatcher();
  },

  methods: {
    initCheckboxWatcher() {
      const form = this.$refs[this.checkboxConfig.formRef]?.$el;
      if (!form) {
        console.warn(`Form with ref "${this.checkboxConfig.formRef}" not found`);
        return;
      }

      form.addEventListener('change', this.handleCheckboxChange);
    },

    handleSelectAllCb() {
      const form = this.$refs[this.checkboxConfig.formRef]?.$el;
      if (!form) {
        console.warn(`Form with ref "${this.checkboxConfig.formRef}" not found`);
        return;
      }
      this.checkboxConfig.targetArray.length = 0;
      for (let i = 0; i < form.getElementsByClassName('el-checkbox__original').length; i++) {
        const name = form.getElementsByClassName('el-checkbox__original').item(i).name;
        if (isNotBlank(name)) {
          this.checkboxConfig.targetArray.push(name);
        }
      }
      // 默认 record_date 兼容
      let hasRecordDate = false;
      this.checkboxConfig.targetArray.forEach((item) => {
        if (item.includes('record_date')) {
          hasRecordDate = true;
        }
      });
      if (!hasRecordDate) {
        this.checkboxConfig.targetArray.push('record_date');
      }
      if (this.checkboxConfig.searchFunc) {
        this.checkboxConfig.searchFunc.call();
      }
    },
    /**
     * 处理指定勾选
     */
    handleSelectSpecialCb(...keys) {
      keys.forEach((key) => {
        this.checkboxConfig.targetArray.push(key);
      });
      if (this.checkboxConfig.searchFunc) {
        this.checkboxConfig.searchFunc.call();
      }
    },
    handleUnSelectAllCb() {
      this.checkboxConfig.targetArray.length = 0;
      this.checkboxConfig.targetArray.push('record_date');
    },
    handleSelectAffId() {
      this.checkboxConfig.targetArray.length = 0;
      this.checkboxConfig.targetArray.push('record_date');
      this.checkboxConfig.targetArray.push('aff_id');
    },
    handleCheckboxChange(event) {
      const target = event.target;
      if (!target.className.includes('el-checkbox__original')) return;

      const checkbox = target.closest('.el-checkbox');
      const name = checkbox.querySelector('input').getAttribute('name');

      const config = this.checkboxConfig;

      // 获取当前数组
      const currentArray = this.checkboxConfig.targetArray;

      if (target.checked) {
        // 处理勾选
        const value = config.transform ? config.transform(name) : name;
        const newArray = [...currentArray, value];
        this.checkboxConfig.targetArray.push(value);

        // 执行回调
        if (config.onCheck) {
          config.onCheck.call(this, value, newArray);
        }
        if (config.searchFunc) {
          config.searchFunc.call();
        }

        this.$nextTick(() => {
          //在数据加载完，重新渲染表格
          if (this.$refs[this.checkboxConfig.tableRef]) {
            this.$nextTick(() => {
              this.$refs[this.checkboxConfig.tableRef].doLayout();
            });
          }
        });
      } else {
        // 处理取消勾选
        const newArray = currentArray.filter((item) => item !== name);
        this.checkboxConfig.targetArray.splice(currentArray.indexOf(name), 1);

        // 执行回调
        if (config.onUncheck) {
          config.onUncheck.call(this, name, newArray);
        }
      }
    },
  },

  beforeDestroy() {
    // 清理事件监听
    const form = this.$refs[this.checkboxConfig.formRef]?.$el;
    if (form) {
      form.removeEventListener('change', this.handleCheckboxChange);
    }
  },
};
